
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/releases",
      function () {
        return require("private-next-pages/releases.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/releases"])
      });
    }
  